//libraries
import _ from 'lodash';

/**
 * Import all constants as an object.
 */
import * as actionType from "../../constants/actionType";


let initialState = {
    loans: [],
    isLoanHit: false
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
export default function (state, action) {
    state = state || initialState;
    switch (action.type) {
        case actionType.CLIENT_SMMARY_LOAN:
            return _.assign({}, state, {
                loans: action.payload.loans,
                isLoanHit: action.payload.isLoanHit
            });
        case actionType.CLIENT_SUMMARY_LOAN_RESET:
            return initialState;
        default:
            return state;
    }
}